// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Menu from "Screens/Menu/Menu";
import FooterLanguage from "./FooterLanguage";
import Loading from "./Loading";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { get_dictionaries } from "http/components/Requests";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { enTexts } from "Utils/Languages/locales/EN";
import { frTexts } from "Utils/Languages/locales/FR";
import { itTexts } from "Utils/Languages/locales/IT";
import Dialog from "./Dialog";

export default function Layout() {
  const dispatch = useDispatch();

  useEffect(() => {
    getDictionaries();
  }, []);

  const getDictionaries = async () => {
    dispatch(HandleLoading(true));
    const response = await get_dictionaries();
    if (CheckApiStatus(response)) {
      Object.keys(response.data.en).map((key) => {
        const _v = response.data.en[key];
        Object.keys(_v).map((vkey) => {
          enTexts[vkey] = _v[vkey];
        });
      });
      Object.keys(response.data.fr).map((key) => {
        const _v = response.data.fr[key];
        Object.keys(_v).map((vkey) => {
          frTexts[vkey] = _v[vkey];
        });
      });
      Object.keys(response.data.it).map((key) => {
        const _v = response.data.it[key];
        Object.keys(_v).map((vkey) => {
          itTexts[vkey] = _v[vkey];
        });
      });
    }
    dispatch(HandleLoading(false));
  };

  return (
    <div className="app-home" id="maindiv">
      {/* <div className='rect-home-page' /> */}
      <Loading />
      <Dialog />
      <Menu />
      <div className="main-paper" id="mainpaper" key={"main-paper"}>
        <div className="paper-body" id="paperbody" key={"paper-body"}>
          <Outlet />
        </div>
      </div>
      {/* <FooterLanguage /> */}
    </div>
  );
}
